import allAboutMyDay from '@/api/all-about-my-day'
// import student from '@/api/student-profile'
// import ClassOperation from '@/api/class-operation'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState,
  edit_data: {},
  student_id: null
}

export const getters = {}

export const mutations = {
  ...baseMutations,
  SET_EDIT_DATA(state, data) {
    state.edit_data = data
  },
  SET_STUDENT_ID(state, data) {
    state.student_id = data
  }
}

export const actions = {
  fetch(context, attrubutes = {}) {
    let params = Object.assign(
      {
        student_id: context.state.student_id,
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search
      },
      attrubutes
    )
    return allAboutMyDay.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  store(context, data) {
    return allAboutMyDay.store(data)
  },

  update(context, data) {
    return allAboutMyDay.update(data)
  },
  destroy(context, id) {
    return allAboutMyDay.destroy(id)
  },

  async find(context, id) {
    if (_.isEmpty(context.state.edit_data)) {
      let response = await allAboutMyDay.find(id)
      context.commit('SET_EDIT_DATA', response.data)
    }
  },
  getClass(context, attributes = {}) {
    return allAboutMyDay.classRoom({ attributes })
  },
  getFindData(context, attributes = {}) {
    let params = Object.assign({
      class_id: attributes.class_id,
      student_id: attributes.student_id,
      activity_date: attributes.activity_date
    })
    return allAboutMyDay.findData({ params })
  },
  async getStudent(context, attributes = {}) {
    let params = Object.assign({
      class_id: attributes.class_id
    })
    return allAboutMyDay.student({ params })
  },
  getSetting(context) {
		return allAboutMyDay.getSetting()
  },
  manualRelease(context) {
		return allAboutMyDay.manualRelease()
  }
}
